import { LayoutProps, VerticalLayout } from '@jsonforms/core';
import { Form } from 'antd';
import { LayoutRenderer } from './LayoutRenderer';
import { LayoutRendererProps } from './GroupLayout';

export const GroupRenderer = ({
  path,
  enabled,
  visible,
  schema,
  renderers,
  cells,
  uischema,
}: LayoutProps) => {
  const { elements } = uischema as VerticalLayout & { label?: string };
  const childProps: LayoutRendererProps = {
    elements,
    schema,
    path,
    enabled,
    direction: 'column',
    visible,
  };

  return (
    <Form.Item style={{ display: visible ? 'block' : 'none', margin: 0 }}>
      <LayoutRenderer {...childProps} renderers={renderers} cells={cells} className={'mt-3'} />
    </Form.Item>
  );
};
